import apiClient from '../api.js';

// Capa de servicios para el flujo de "Materia Origen" de Preconvalidacion
// (import/actualización de materias y temas provenientes de universidades
// externas). Extraído de `MateriaOrigenPreConv.vue`, que hacía las llamadas
// axios inline sin pasar por esta capa.
//
// Contrato asumido (legacy, mismo estilo que el resto de `/estudiante/...`):
// las respuestas de error de estos endpoints exponen el mensaje vía
// `.message` (a diferencia de los endpoints nuevos en capas, que usan
// `.mensaje`) — verificar contra el backend real si algo no calza.
//
//   GET  /estudiante/listarimportmateriaext/:idSede
//        -> { resultado: [{ nomuniext, sigext, ubiext, carrext, codig, materi,
//                            ch, id_materia_externa, id_universidad_ext }] | null }
//
//   GET  /estudiante/listartemaext/:idSede,:idUniversidadExt,:idMateriaExt
//        -> { resultado: [{ nomtema, titulotema, cont }] | null }
//
//   POST /estudiante/actualizarTemasMateriaExt/
//        body { id_materia_externa, temas } -> { message, type }
//
//   POST /estudiante/eliminarMateriaExterna/:idMatExt,:idPlanEstudio,:unicodigo,:idSede
//        -> { message, type }

const resource = '/estudiante';

const useEstudiantePreconvalidacionApi = {
  listarMateriasImportar(idSede) {
    return apiClient.get(`${resource}/listarimportmateriaext/${idSede}`);
  },

  listarTemasExternos(idSede, idUniversidadExt, idMateriaExt) {
    return apiClient.get(`${resource}/listartemaext/${idSede},${idUniversidadExt},${idMateriaExt}`);
  },

  actualizarTemasMateriaExterna(datos) {
    return apiClient.post(`${resource}/actualizarTemasMateriaExt/`, datos);
  },

  eliminarMateriaExterna(idMatExt, idPlanEstudio, unicodigo, idSede) {
    return apiClient.post(`${resource}/eliminarMateriaExterna/${idMatExt},${idPlanEstudio},${unicodigo},${idSede}`);
  },
};

export default useEstudiantePreconvalidacionApi;
